import { FC } from 'react';

import { CampaignProcess } from 'utils/constants/campaign';

import { BannerLink } from 'components/CpcFlexibleCreate/CpcForm/BannerLink/BannerLink';
import { Vacancies } from 'components/CpcFlexibleCreate/CpcForm/Vacancies/Vacancies';

import { selectCampaignProcess } from 'store/models/createCampaign';
import { selectIsMainMenuDataExist } from 'store/models/mainMenu';
import { useSelector } from 'store/utils';

export const VacancyOrLinkChoice: FC = () => {
    const isMainMenuDataExist = useSelector(selectIsMainMenuDataExist);
    const campaignProcess = useSelector(selectCampaignProcess);

    if (isMainMenuDataExist && campaignProcess === CampaignProcess.Create) {
        return null;
    }

    return (
        <>
            <Vacancies />
            <BannerLink />
        </>
    );
};
